export default "__VITE_ASSET__DWCXhZvN__"